/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Admin_CommentInputs */

const en_admin_external_booking_edit_admin_comment = /** @type {(inputs: Admin_External_Booking_Edit_Admin_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin comment:`)
};

const de_admin_external_booking_edit_admin_comment = /** @type {(inputs: Admin_External_Booking_Edit_Admin_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Kommentar:`)
};

const es_admin_external_booking_edit_admin_comment = /** @type {(inputs: Admin_External_Booking_Edit_Admin_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentario del administrador:`)
};

const fr_admin_external_booking_edit_admin_comment = /** @type {(inputs: Admin_External_Booking_Edit_Admin_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commentaire admin :`)
};

const nl_admin_external_booking_edit_admin_comment = /** @type {(inputs: Admin_External_Booking_Edit_Admin_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adminopmerking:`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Admin_CommentInputs) => LocalizedString} */
const it_admin_external_booking_edit_admin_comment = en_admin_external_booking_edit_admin_comment;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_CommentInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_admin_comment = en_admin_external_booking_edit_admin_comment;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_CommentInputs) => LocalizedString} */
const pl_admin_external_booking_edit_admin_comment = en_admin_external_booking_edit_admin_comment;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_CommentInputs) => LocalizedString} */
const hu_admin_external_booking_edit_admin_comment = en_admin_external_booking_edit_admin_comment;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_CommentInputs) => LocalizedString} */
const ro_admin_external_booking_edit_admin_comment = en_admin_external_booking_edit_admin_comment;

/**
* | output |
* | --- |
* | "Admin comment:" |
*
* @param {Admin_External_Booking_Edit_Admin_CommentInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_admin_comment = /** @type {((inputs?: Admin_External_Booking_Edit_Admin_CommentInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Admin_CommentInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_admin_comment(inputs)
	if (locale === "de") return de_admin_external_booking_edit_admin_comment(inputs)
	if (locale === "es") return es_admin_external_booking_edit_admin_comment(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_admin_comment(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_admin_comment(inputs)
	if (locale === "it") return it_admin_external_booking_edit_admin_comment(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_admin_comment(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_admin_comment(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_admin_comment(inputs)
	return ro_admin_external_booking_edit_admin_comment(inputs)
});
export { admin_external_booking_edit_admin_comment as "admin.external_booking_edit.admin_comment" }